
export default (buffer = '') => 
  JSON.parse(Buffer.from(buffer, 'base64').toString('ascii'))